module.exports = __webpack_public_path__ + "static/media/fail.238d82ad.png";